/**
 * The six questions the homepage answers inline, in ONE place.
 *
 * Why the homepage carries an FAQ at all: an AI-SEO audit flagged
 * "FAQ-like content exists without FAQPage schema" on `/`. The honest fix is
 * not to bolt schema onto question-shaped marketing headings ("Ready to get in
 * front of investors?") — that would be markup asserting Q&A the page does not
 * actually answer. It is to put real answers on the page and mirror exactly
 * those in JSON-LD.
 *
 * Why these keys and not new copy: every question below already exists on
 * /faq, with an answer that survived the audit which stripped two claims banned
 * by docs/BRAND_ENTITY_KIT.md. Re-typing them here would create a second
 * wording of the same answer on a second URL — the drift that
 * app/(routes)/faq/faq-categories.ts exists to prevent. Both the visible
 * homepage FAQ and the homepage FAQPage JSON-LD resolve these keys against
 * pageContent.faq.questions, so the homepage cannot contradict /faq or itself.
 *
 * Chosen for the six questions an answer engine is actually asked about a
 * fundraising tool: what it is, how it works, how many investors, what it
 * costs, whether it takes a cut, and whether the investors are real.
 *
 * Not a client component: app/(routes)/page.tsx is a server component and
 * cannot import from a 'use client' module without pulling it into the client
 * bundle.
 */
export const HOME_FAQ_KEYS: string[] = [
  'whatIsSendVC',
  'howDoesItWork',
  'howManyInvestors',
  'howMuchDoesItCost',
  'areThereCommissions',
  'investorVerification',
];
